import { Box } from '@mui/material';

import { BreadcrumbProps, Breadcrumbs } from '../router/BreadCrumbs';

interface Props {
    breadcrumbs: BreadcrumbProps['items'];
}

export function ActionBar({
    children,
    breadcrumbs,
}: React.PropsWithChildren<Props>) {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginY={2}
        >
            <Breadcrumbs items={breadcrumbs} />
            <Box display="flex" flexDirection="row">
                {children}
            </Box>
        </Box>
    );
}
